module.exports = __webpack_public_path__ + "img/bj23.073534b0.png";